/* eslint-disable mastery/named-colors */
import {
  assignVars,
  createThemeContract,
  globalStyle,
} from '@vanilla-extract/css';
import { gray, semanticMap } from './newBaseColors';

const spectrum = { ...semanticMap, gray };

export const appThemeContract = createThemeContract(spectrum);

// Apply base color theme contract
globalStyle(':root', {
  vars: assignVars(appThemeContract, spectrum),
});

// Dark mode overrides for base colors
globalStyle(':root.theme-dark', {
  vars: assignVars(
    {
      gray: appThemeContract.gray,
      primary: appThemeContract.primary,
      success: appThemeContract.success,
      warning: appThemeContract.warning,
      neutral: appThemeContract.neutral,
      cyan: appThemeContract.cyan,
      violet: appThemeContract.violet,
      error: appThemeContract.error,
      selectedRow: appThemeContract.selectedRow,
      card: appThemeContract.card,
      hover: appThemeContract.hover,
    },
    {
      gray: {
        // Grays are inverted in dark mode (100 becomes darkest, 10 becomes lightest)
        100: gray[20],
        white: gray[10],
        99: gray[20],
        97: gray[10],
        95: gray[20],
        92: '#E9E9E9',
        91: '#E6E5E7',
        90: gray[30],
        80: gray[30],
        70: gray[60],
        60: gray[70],
        50: gray[80],
        45: '#5E5E62',
        40: gray[90],
        30: gray[95],
        20: gray[99],
        17: '#292B30',
        12: gray[12],
        10: gray[95],
        0: '#000000',
      },
      primary: {
        99: '#FCFDFF',
        98: '#F5F7FF',
        95: '#EDF0FF',
        90: '#D8E2FF',
        80: '#ADC6FF',
        70: '#80ABFF',
        60: '#4B8EFF',
        50: '#1E73E8',
        40: '#1662C5',
        30: '#004493',
        20: '#002E69',
        10: '#001A41',
      },
      success: {
        99: '#F4FFF5',
        97: '#DCFFEB',
        95: '#CCFFE1',
        90: '#B0EFD0',
        80: '#65DCA4',
        70: '#46C08A',
        60: '#20A471',
        50: '#00885B',
        40: '#006C47',
        30: '#005235',
        20: '#003823',
        10: '#002113',
      },
      warning: {
        99: '#FFFDF7',
        97: '#FFF6E1',
        95: '#FFECC2',
        90: '#FFD885',
        80: '#FFCB5C',
        70: '#F5A700',
        60: '#C38400',
        50: '#A16C00',
        45: '#815600',
        40: semanticMap.warning[80],
        30: '#614000',
        20: '#442B00',
        10: '#291800',
      },
      neutral: {
        100: semanticMap.neutral[20],
        white: '#FFFFFF',
        99: semanticMap.neutral[12],
        97: '#F7F6F7',
        95: '#F2F0F4',
        92: '#E9E9E9',
        91: '#E6E5E7',
        90: semanticMap.neutral[12],
        80: semanticMap.neutral[40],
        70: '#ABABAF',
        60: semanticMap.neutral[30],
        50: '#77777A',
        45: '#5E5E62',
        40: '#5E5E62',
        30: semanticMap.neutral[90],
        20: semanticMap.neutral[80],
        17: '#292B30',
        12: '#2F3136',
        10: '#1B1B1F',
        0: '#000000',
      },
      cyan: {
        99: '#ECFBFF',
        97: '#F8FDFF',
        95: '#D8F6FF',
        90: '#ABEDFF',
        80: '#55D6F4',
        70: '#2DBAD7',
        60: '#009FB9',
        50: '#008399',
        40: '#00687A',
        30: '#004E5C',
        20: '#003640',
        10: '#001F26',
      },
      violet: {
        99: '#FEFBFF',
        97: '#FDF4FF',
        95: '#FCEBFF',
        90: '#F5D9FF',
        80: '#E7B4FF',
        70: '#D78DFF',
        60: '#C762FF',
        50: '#AE3EEB',
        40: semanticMap.violet[80],
        30: '#7100A5',
        20: '#500076',
        10: '#30004A',
      },
      error: {
        99: '#FFFBFF',
        97: '#FFF3F5',
        95: '#FEE7EB',
        90: '#FFDAD5',
        80: '#FFB4AB',
        70: '#FF897D',
        60: '#FB6156',
        50: '#DE372F',
        40: '#BA1A1A',
        30: '#930009',
        20: '#690004',
        10: '#410002',
      },
      selectedRow: {
        background: semanticMap.primary[20],
      },
      card: {
        background: '#292B30', /// specified background,
      },
      hover: {
        background: semanticMap.primary[20],
      },
    },
  ),
});
